import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShield2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 5.25348L12 1.4353L21 5.25348V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V5.25348Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShield2;
